// Carte miniature du contour de la parcelle et de ses îlots : non interactive, cadrée sur la parcelle.
import { MapContainer, TileLayer, GeoJSON } from "react-leaflet";
import "leaflet/dist/leaflet.css";
import { MapPinned } from "lucide-react";
import { useNavigate } from "react-router-dom";
import { DRAW_LAYER, MAX_ZOOM } from "@/lib/mapLayers";
import { COL } from "./shared";

function bounds(geometry) {
  const rings = geometry?.type === "Polygon" ? [geometry.coordinates?.[0]]
    : geometry?.type === "MultiPolygon" ? (geometry.coordinates || []).map((p) => p?.[0]) : [];
  const pts = rings.filter(Boolean).flat();
  if (!pts.length) return null;
  const lats = pts.map((c) => c[1]);
  const lngs = pts.map((c) => c[0]);
  return [[Math.min(...lats), Math.min(...lngs)], [Math.max(...lats), Math.max(...lngs)]];
}

export default function FicheMiniCarte({ parcelId, geometry, ilots = [], className = "h-48" }) {
  const navigate = useNavigate();
  const b = bounds(geometry);
  return (
    <div className={`relative rounded-2xl overflow-hidden border bg-white ${className}`} style={{ borderColor: COL.line }} data-testid="fiche-mini-carte">
      {b ? (
        <MapContainer bounds={b} boundsOptions={{ padding: [16, 16] }} maxZoom={MAX_ZOOM} className="h-full w-full"
          dragging={false} zoomControl={false} scrollWheelZoom={false} doubleClickZoom={false} touchZoom={false}
          boxZoom={false} keyboard={false} attributionControl={false} style={{ background: "#E9ECE8" }}>
          <TileLayer url={DRAW_LAYER.url} maxZoom={MAX_ZOOM} maxNativeZoom={DRAW_LAYER.maxNativeZoom} />
          <GeoJSON data={{ type: "Feature", geometry }} style={{ color: "#FFFFFF", weight: 2.5, fillColor: COL.green, fillOpacity: 0.12 }} interactive={false} />
          {ilots.filter((i) => i.geometry).map((i) => (
            <GeoJSON key={i.ilot_id} data={{ type: "Feature", geometry: i.geometry }} interactive={false}
              style={{ color: "#F4D35E", weight: 1.5, dashArray: "4 3", fillOpacity: 0.1 }} />
          ))}
        </MapContainer>
      ) : (
        <div className="h-full flex items-center justify-center text-sm text-gray-500">Contour indisponible</div>
      )}
      <button
        type="button"
        onClick={() => navigate(`/map?parcel=${encodeURIComponent(parcelId)}`)}
        className="absolute bottom-2 right-2 z-[450] min-h-[44px] px-4 rounded-full bg-white/95 text-sm font-semibold flex items-center gap-2 shadow-sm"
        style={{ color: COL.green }}
        data-testid="fiche-ouvrir-carte"
      >
        <MapPinned className="w-4 h-4" /> Ouvrir la carte
      </button>
    </div>
  );
}
